<div
  #eventRef
  (click)="handleEventClick()"
  class="event-full"
  [ngClass]="{
    'event-full--inline': inline || (minified && !background),
    'event--minified': minified
  }"
>
  <ng-content
    *ngTemplateOutlet="background ? backgroundTemplate : noBackgroundTemplate"
  ></ng-content>
</div>

<ng-template #eventTemplate>
  <div class="event" [class.event--active]="isActive">
    <div class="event__body">
      <div class="event__content">
        <div class="event__text">
          <div
            class="event__category mb-2"
            #categoryList
            [ngClass]="{ 'event__category--hidden': hideListItems }"
          >
            <div
              *ngFor="let category of displayedCategories"
              [attr.data-id]="category.category_id"
              class="event__category-item"
            >
              <a
                (click)="$event.stopPropagation()"
                href=""
                [routerLink]="['/results']"
                [queryParams]="{ categories: [category.category_id] }"
                queryParamsHandling="merge"
              >
                <app-category-badge
                  [title]="getTitle(category.category_title)"
                  [isLink]="true"
                >
                  {{ category.category_title }}
                </app-category-badge>
              </a>
            </div>

            <a (click)="$event.stopPropagation()">
              <app-category-badge
                *ngIf="hiddenCategoryCount > 0"
                [title]="hiddenCategoryTitle"
                [tooltipCategories]="hiddenCategories"
              >
                + {{ hiddenCategoryCount }}
              </app-category-badge>
            </a>
          </div>
          <div class="event__time mb-3" *ngIf="minified">
            <app-date-time
              [dateTime]="event.event_start"
              [small]="true"
            ></app-date-time>
          </div>
          <div
            class="event__name semi-bold"
            [ngClass]="{ 'text-big': !minified }"
          >
            {{ event.event_name }}
          </div>
          <div class="info-container d-flex mt-4 mb-3" *ngIf="!minified">
            <app-date-time [dateTime]="event.event_start"></app-date-time>
            <app-location [location]="location"></app-location>
          </div>
          <div *ngIf="!minified">
            <app-expand
              [expanded]="isExpanded"
              (stateChange)="isExpanded = $event"
            >
              <!-- ql-editor class is needed so that the same formatting as within the editor is applied -->
              <div
                #expandableContentRef
                content
                class="event__description ql-editor text-medium mb-2"
                [innerHTML]="event.event_description"
              ></div>
            </app-expand>

            <div class="mt-3">
              <p class="dark semi-bold mb-2 text-medium">Place</p>
              <app-google-map
                class="event__location-map"
                [locationString]="event.event_location"
              ></app-google-map>
            </div>
          </div>
          <div class="event__location mt-1" *ngIf="minified">
            <app-location [location]="location" [small]="true"></app-location>
          </div>
        </div>
      </div>
      <div class="event__controls">
        <app-button
          *ngIf="event.event_registration_open && !minified"
          [submit]="true"
          (click)="openRegistration($event)"
          [buttonSize]="'medium'"
        >
          <span class="pr-3 pl-3">Register</span>
        </app-button>
        <app-like-checkbox [fc]="likeControl"></app-like-checkbox>
      </div>
    </div>
    <div class="event__divider"></div>
    <div
      class="event__footer d-flex justify-content-between align-items-center"
    >
      <app-event-by
        [organization]="event.organization"
        [small]="minified"
      ></app-event-by>

      <app-button
        class="view-button"
        *ngIf="showViewButton"
        [buttonSize]="minified ? 'extra-small' : 'medium'"
        buttonStyle="neutral"
        [fullWidth]="false"
        [title]="('open' | t) + ' ' + event.event_name"
        (click)="goToEventPage($event, event.event_id)"
      >
        View event
      </app-button>
    </div>
  </div>
</ng-template>

<ng-template #eventFull>
  <div class="event-full" [ngClass]="{ 'event-full--inline': inline }">
    <ng-content
      *ngTemplateOutlet="background ? backgroundTemplate : noBackgroundTemplate"
    ></ng-content>
  </div>
</ng-template>

<ng-template #eventMinified>
  <ng-content
    *ngTemplateOutlet="background ? backgroundTemplate : noBackgroundTemplate"
  ></ng-content>
</ng-template>

<ng-template #backgroundTemplate>
  <div
    class="event-full__background"
    [class.event-full__background--full-width]="backgroundFullWidth"
    [ngStyle]="dynamicStyles"
  ></div>

  <div class="event-full__content d-flex justify-content-center">
    <ng-content *ngTemplateOutlet="eventTemplate"></ng-content>
  </div>
</ng-template>

<ng-template #noBackgroundTemplate>
  <ng-content *ngTemplateOutlet="eventTemplate"></ng-content>
</ng-template>

<ng-template #unauthorizedUserPopup>
  <app-unauthorized-user-popup
    [title]="'track_liked_events' | t"
    [helpText]="'track_liked_events_help_text' | t"
  ></app-unauthorized-user-popup>
</ng-template>
